export class FormPermission {
  permissionID: number;
  roleName: string;
  notification: number;
  doctor: number;
  mamjiUser: number;
  pharmacy: number;
  reception: number;
  diagnostic: number;
  reports: number;
  settings: number;
}
